import {useAppTokens} from '../theme'

interface LoadingLogoProps {
  size?: number
}

// Brand-coloured loading indicator: the logo silhouette filled with a moving
// purple→white→purple gradient. The shimmer wave passes diagonally through
// the mark, giving a subtle "alive" effect at any size.
const LoadingLogo = ({size = 32}: LoadingLogoProps) => {
  const tokens = useAppTokens()
  return (
    <span
      role="progressbar"
      aria-busy="true"
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        WebkitMaskImage: 'url(/logo.svg)',
        maskImage: 'url(/logo.svg)',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        background: `linear-gradient(115deg, ${tokens.accent.dark} 0%, ${tokens.accent.primary} 25%, #FFFFFF 50%, ${tokens.accent.primary} 75%, ${tokens.accent.dark} 100%)`,
        backgroundSize: '300% 100%',
        animation: 'logoShimmer 1.6s linear infinite',
      }}
    />
  )
}

export default LoadingLogo
